module.exports = __webpack_public_path__ + "static/media/qrcode_mini_be.3cebdb03.svg";